import { FeatureFlag, UserRole } from '@synergy/models';
import { Navigate } from 'react-router';
import { ReactNode } from 'react';
import { hasFeature, hasRole } from '@synergy/utils';

import { useSelector } from '../../../store/use-appstate-selector';

interface AccessControlProps {
    allowedRoles?: UserRole | UserRole[];
    redirect?: boolean;
    children: ReactNode;
    allowedFeature?: FeatureFlag;
}

export const AccessControl = (props: AccessControlProps) => {
    const user = useSelector(state => state.user);

    const { allowedRoles, allowedFeature, redirect, children } = props;

    const allowedByRoles = !(allowedRoles && allowedRoles.length > 0) || hasRole(allowedRoles, user);
    const allowedByFeatureFlag = !allowedFeature || hasFeature(allowedFeature);

    const allowed = allowedByRoles && allowedByFeatureFlag;

    if (allowed) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <>{children}</>;
    }

    if (redirect) {
        return <Navigate to="/" />;
    }
    return null;
};
